import { render } from "./Boys.vue?vue&type=template&id=2cc5510c"
import script from "./Boys.vue?vue&type=script&lang=js"
export * from "./Boys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__